import MuiGrid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import styles from './styles'

const useStyles = makeStyles(styles)

/**
 * @typedef {import('@material-ui/core/Grid').GridProps} MuiGridProps
 *
 * @typedef {MuiGridProps & {
 *   children?: React.ReactNode;
 *   style?: React.CSSProperties;
 *   className?: string;
 *   spacing?: number;
 *   padding?: number;
 *   item?: boolean;
 * }} GridProps
 */

/**
 * ```
 * import { Grid } from '@pickupp/ui/core'
 * ```
 *
 * https://material-ui.com/api/grid/
 */

/**
 * @param {GridProps} props
 */
const Grid = ({
  padding = 0,
  spacing = 0,
  children,
  className,
  style,
  item = false,
  ...muiProps
}) => {
  const classes = useStyles({ padding })

  return (
    <MuiGrid
      container
      spacing={spacing}
      classes={{
        container: classes.container,
      }}
      className={className}
      style={style}
      item={item}
      {...muiProps}
    >
      {children}
    </MuiGrid>
  )
}

export default Grid
